import { useState } from "react";
import Header from "@/components/landing/Header";
import Footer from "@/components/landing/Footer";
import Services from "@/components/landing/Services";
import QuoteWizard from "@/components/landing/QuoteWizard";

export default function ServicesPage() {
  const [wizardOpen, setWizardOpen] = useState(false);
  return (
    <div className="min-h-screen bg-[#0A0A0A]" data-testid="services-page">
      <Header onQuoteClick={() => setWizardOpen(true)} />
      <main className="relative z-10 pt-12">
        <Services />
      </main>
      <Footer />
      <QuoteWizard open={wizardOpen} onClose={() => setWizardOpen(false)} />
    </div>
  );
}
